import { render } from "./TelaLoginAdm.vue?vue&type=template&id=0ecad980&scoped=true"
import script from "./TelaLoginAdm.vue?vue&type=script&lang=js"
export * from "./TelaLoginAdm.vue?vue&type=script&lang=js"

import "./TelaLoginAdm.vue?vue&type=style&index=0&id=0ecad980&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecad980"]])

export default __exports__